import * as React from "react";
import "./GenericSection.css";
import { match, Route } from "react-router";
import { HRSectionWithStatus, HRSubSectionWithStatus } from "../models/HR";
import { AgencyId, HRQuestionId, HRSubSectionId } from "../messages";
import { CaregiverCertification, HRQuestionGroupId, HRSectionId, HRSectionStageId } from "../messages/ObjectIds";
import { GenericSubSection } from "./GenericSubSection";
import * as H from "history";
import * as Scroll from "react-scroll";
import { delay } from "../system/delay";
import { API } from "../API";
import { MobileStickyHeader } from "./widgets/MobileStickyHeader";
import { CertificationSettings } from "../messages/Agency";

interface GenericSectionProps {
    handleSubSectionChange: (id: HRSubSectionId, history: H.History, match: match<any>) => void;
    clickedSubSection: HRSubSectionId;
    sectionDetails: HRSectionWithStatus;
    sectionList: HRSectionWithStatus[];
    matchUrl: string;
    // TODO give type to newval
    onAnswerChange: (newVal: any, questionId: HRQuestionId, groupId: HRQuestionGroupId, subSectionId: HRSubSectionId) => void;
    onAnswerBlur: (questionId: HRQuestionId, groupId: HRQuestionGroupId, subSectionId: HRSubSectionId) => void;
    onTriggerEvaluateHierarchyStatus: (questionId: HRQuestionId, groupId: HRQuestionGroupId, subSectionId: HRSubSectionId) => void;
    getCertificationPayRates: () => CertificationSettings;
    clickedSection: HRSectionId | null;
    onLinkToSectionClick: (sectionId: HRSectionId, isLocked: boolean) => void;
    onNextButtonClick: () => void;
    onDocumentGeneratedStatusChange: (subSectionId: HRSubSectionId, isGenerated: boolean) => void;
    onTestTryAgain: (subSectionId: HRSubSectionId) => void;
    api: API;
    sectionCount: number;
    useAltLinkUI: boolean;
    closePopupForMobile: () => void;
    selectedCertification: CaregiverCertification;
}

export interface GenericSectionState {
    showSectionOnMobile: boolean;
}

export const scrollDuration = 1500;

export class GenericSection extends React.Component<GenericSectionProps, GenericSectionState> {
    constructor(props: GenericSectionProps) {
        super(props);
        this.state = {
            showSectionOnMobile: true
        };
    }

    async handleSubSectionClicked(changeTo: HRSubSectionId, history: H.History, match: match<any>) {
        this.props.handleSubSectionChange(changeTo, history, match);
    }

    shouldNotifyAgencyStageCompleted = (HRSectionWithStatus: HRSectionWithStatus[], stageId: HRSectionStageId) => {
        const sections = HRSectionWithStatus.filter(x => x.data.HRSectionStageId === stageId);
        return !sections.some(x => x.status !== 100);
    }

    handleNextButtonClick = async (history: H.History, match: match<any>) => {
        let index: undefined | number;
        const curr = this.props.sectionDetails.subSections.find((subsection, i) => {
            if (subsection.data.id === this.props.clickedSubSection) {
                index = i;
                return true;
            }
            return false;
        });
        if (curr !== undefined && index !== undefined) {
            // check if the caregiver completed all sections of the stage and notify agency
            const stageId = this.props.sectionDetails.data.HRSectionStageId;
            if (stageId !== null && this.shouldNotifyAgencyStageCompleted(this.props.sectionList, stageId)) {
                this.props.api.postUpdateCaregiverFinishedStage(stageId);
            }
            if (index === this.props.sectionDetails.subSections.length - 1) {
                await this.props.onNextButtonClick();
            } else {
                const next = this.props.sectionDetails.subSections[index + 1];
                Scroll.scroller.scrollTo("" + curr.data.id, {
                    duration: scrollDuration,
                    delay: 0,
                    smooth: true
                });
                // Animation needs to finish
                await delay(scrollDuration + 100);
                this.props.handleSubSectionChange(next.data.id, history, match);
            }
        }
    }

    closeSectionForMobile = () => {
        this.props.closePopupForMobile();
    }

    render() {
        return (
            <div className={`GenericSection__bigSectionHolder ${this.props.clickedSection !== null ? "" : "GenericSection_hideSection"}`}>
                <div className={"GenericSection__subSectionContainer"}>
                    <MobileStickyHeader title={this.props.sectionDetails.data.title} close={this.closeSectionForMobile} />
                    {this.props.sectionDetails.subSections.map((subSection: HRSubSectionWithStatus) => {
                        return (
                            <Route
                                key={HRSubSectionId.unwrap(subSection.data.id)}
                                path={this.props.matchUrl + "/" + this.props.sectionDetails.data.id}
                                render={(props) =>
                                    <GenericSubSection
                                        {...props}
                                        matchUrl={props.match.url}
                                        onLinkToSubSectionClick={(subSectionId) => this.handleSubSectionClicked(subSectionId, props.history, props.match)}
                                        isClicked={this.props.clickedSubSection === subSection.data.id}
                                        subSectionDetails={subSection}
                                        onAnswerChange={(newVal, questionId, groupId) => this.props.onAnswerChange(newVal, questionId, groupId, subSection.data.id)}
                                        onAnswerBlur={(questionId, groupId) => this.props.onAnswerBlur(questionId, groupId, subSection.data.id)}
                                        onTriggerEvaluateHierarchyStatus={(questionId, groupId) => this.props.onTriggerEvaluateHierarchyStatus(questionId, groupId, subSection.data.id)}
                                        getCertificationPayRates={() => this.props.getCertificationPayRates()}
                                        onNextButtonClick={() => this.handleNextButtonClick(props.history, props.match)}
                                        onDocumentGeneratedStatusChange={this.props.onDocumentGeneratedStatusChange}
                                        onTestTryAgain={this.props.onTestTryAgain}
                                        api={this.props.api}
                                        selectedCertification={this.props.selectedCertification}
                                    />
                                }
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GenericSection.tsx